import baseURL from '../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { loadingAction } from '../redux/actions/loadingAction';
import handleRefreshToken from './RefreshToken';

export const handleGetRequest = async (url, isShowLoad, isShowToast = false, dispatch) => {
    try {
        if (isShowLoad && dispatch) dispatch(loadingAction(true));

        const loginData = JSON.parse(localStorage.getItem('user'));
        const accessToken = loginData?.data?.token;
        const response = await axios.get(`${baseURL + url}`, {
            headers: {
                authorization: `Bearer ${accessToken}`
            }
        });
        if (isShowToast) toast.success(response?.data?.message);
        if (isShowLoad && dispatch) dispatch(loadingAction(false));
        return response.data;
    } catch (error) {
        if (error?.response?.status === 401) {
            const newToken = await handleRefreshToken();
            if (newToken) {
                return await handleGetRequest(url, isShowLoad, isShowToast, dispatch);
            } else {
                localStorage.clear();
                window.location.href = '/';
                toast.error('Session expired. Please log in again.');
                return;
            }
        }
        if (isShowLoad && dispatch) dispatch(loadingAction(false));

        const id = toast.loading('Please wait...');
        if (error?.response?.status === 500) {
            setTimeout(() => {
                toast.update(id, { render: error?.response?.data?.messages || error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong !!', type: 'error', isLoading: false, autoClose: 3000 });
            }, 100);
        } else {
            setTimeout(() => {
                toast.update(id, { render: error?.response?.data?.messages || error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong !!', type: 'warn', isLoading: false, autoClose: 3000 });
            }, 100);
        }
    }
};
